import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { aiSmartCanvasMakeRealBackend } from './ai-smart-canvas-make-real-backend';
import { aiSmartCanvasMakeRealReducer } from './ai-smart-canvas-make-real-reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'aiSmartCanvasMakeReal',
      aiSmartCanvasMakeRealReducer,
    ),
    BackendModule.forFeature(
      'aiSmartCanvasMakeReal',
      aiSmartCanvasMakeRealBackend,
    ),
  ],
})
export class DatastoreAiSmartCanvasMakeRealModule {}
